import script from "./notAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./notAuth.vue?vue&type=script&setup=true&lang=js"

import "./notAuth.vue?vue&type=style&index=0&id=fdba7532&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdba7532"]])

export default __exports__